import { InMemoryProvider, OpenFeature } from "@openfeature/web-sdk";
import { useSuspenseQuery } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";

export type OpenFeatureFlagApi = {
  disabled: boolean;
  variants: Record<string, boolean>;
  defaultVariant: string;
};

export type OpenFeatureFlagConfig = Record<string, OpenFeatureFlagApi>;

export type FeatureFlagsResponse = {
  features: Record<string, OpenFeatureFlagApi>;
};

export function useFeatureFlagsSuspense() {
  return useSuspenseQuery({
    queryKey: ["feature-flags"],
    queryFn: async () => {
      const { data } = await bffAxios.get<FeatureFlagsResponse>("/features");

      return data.features;
    },
  });
}

/**
 * Drops the previous session's flag values. FeatureFlagsProvider installs the new values only after
 * the signed-in app's first render, so without this that render reads the old company's values.
 */
export function resetFeatureFlags() {
  OpenFeature.setProvider(new InMemoryProvider());
}
